import { TaskDetailPage } from '@/pages/bxy/TaskDetailPage';
import { TasksPage } from '@/pages/bxy/TasksPage';
import { useGroupedSurface } from '@/lib/useGroupedSurface';

/**
 * 薯薯全能通 · 任务中心 / 任务详情。
 *
 * `task.*` 的形状与搬小音一致，直接复用 bxy 的页面，只换路由前缀并套上 iOS 分组底色。
 */
export function ShushuTasksPage() {
  useGroupedSurface();
  return <TasksPage app="shushu" />;
}

export function ShushuTaskDetailPage() {
  useGroupedSurface();
  return <TaskDetailPage app="shushu" />;
}
